export const MARITAL_STATUS_MAP = {
  single: 'Solteiro',
  married: 'Casado',
  widower: 'Viúvo',
  divorced: 'Divorciado',
  separated: 'Separado',
  affectionate: 'Cônjuge/Companheiro',
  stable_union: 'União estável',
  others: 'Outros',
};
